import type { Point } from '../SurfaceBase';

export const BBOX_PADDING = 5;
export const HOVER_DELAY = 500;

// NOTE: This is the raw SVG file for the collapsed image icon. Keeping it here for reference.
// original svg:
// <svg fill="#000000" height="25px" width="25px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 113.75 113.75" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"><path d="M0 0v113.75h113.75V0H0zm64.851 20c4.487 0 8.125 3.638 8.125 8.125s-3.638 8.125 -8.125 8.125 -8.125 -3.638 -8.125 -8.125 3.638 -8.125 8.125 -8.125zM93.75 93.75H20v-16.389l20.785 -21.931 24.066 17.198 17.308 -10.068L93.75 74.79V93.75z"/></g></svg>
// view box scaled down svg:
export const imageSvg = `<svg fill="#000000" height="25px" width="25px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 25" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"><path d="M0 0v25h25V0H0zm14.21 4c1.398 0 2.531 1.133 2.531 2.531S15.608 9.062 14.21 9.062 11.68 7.93 11.68 6.531s1.133-2.531 2.531-2.531zM22.656 22.656H2.344v-4.611l3.312-3.5 3.844 2.75 3.5-2.031 3.844 2.25V22.656z"/></g></svg>`;

// This is the "path" of the SVG so we can render it as as Path2D() object on the canvas.
export const svgPath = `M0 0v25h25V0H0zm14.21 4c1.398 0 2.531 1.133 2.531 2.531S15.608 9.062 14.21 9.062 11.68 7.93 11.68 6.531s1.133-2.531 2.531-2.531zM22.656 22.656H2.344v-4.611l3.312-3.5 3.844 2.75 3.5-2.031 3.844 2.25V22.656z`;

// Since the above SVG is 455px x 455px, I scaled it down by a factor of 20 (roughly 23px x 23px)

// height is the same as width (svg is a square)
export const SVG_WIDTH = 25;

export function getBBoxCoordsWhileMinimized(p: Point): [Point, Point, Point, Point] {
  const p1 = {
    x: p.x - SVG_WIDTH / 2 - BBOX_PADDING,
    y: p.y - SVG_WIDTH / 2 - BBOX_PADDING,
  };
  const p2 = {
    x: p1.x + SVG_WIDTH + 2 * BBOX_PADDING,
    y: p1.y,
  };
  const p3 = {
    x: p2.x,
    y: p1.y + SVG_WIDTH + 2 * BBOX_PADDING,
  };
  const p4 = {
    x: p1.x,
    y: p3.y,
  };

  return [p1, p2, p3, p4];
}
